var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:[
    'hit-rate__value',
    'title',
    'u-m-a-0',
    _vm.size,
    _vm.hitRateColorClass ]},[_vm._v("\n  "+_vm._s(_vm.convertFractionToPercent(_vm.hitGoalPercentage))),_c('span',{class:['hit-rate__percent', _vm.size]},[_vm._v("%")])])}
var staticRenderFns = []

export { render, staticRenderFns }